import React from 'react';

var DotsLoader = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("span", null, "\u25CF"),
        React.createElement("span", null, "\u25CF"),
        React.createElement("span", null, "\u25CF")));
};

export { DotsLoader };
